import {
    EDIT_GROUP_MODEL_PERMISSIONS_REQUEST,
    EDIT_GROUP_MODEL_PERMISSIONS_REQUEST_SUCCESS,
    EDIT_GROUP_MODEL_PERMISSIONS_REQUEST_FAILURE,
} from '../constants/edit_group_data.constants';

export const editGroupModelPermissionsRequest = (url, permissions, entity) => ({
    type: EDIT_GROUP_MODEL_PERMISSIONS_REQUEST, url, permissions, entity,
});

export const editGroupModelPermissionsSuccess = (payload, entity) => ({
    type: EDIT_GROUP_MODEL_PERMISSIONS_REQUEST_SUCCESS, payload, entity,
});

export const editGroupModelPermissionsFailure = error => ({
    type: EDIT_GROUP_MODEL_PERMISSIONS_REQUEST_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/actions/edit_group_model_permissions.actions.js